export default __webpack_public_path__ + "static/media/view_list_enable.5b4af4b8.svg";